/* user-register.view.js */
import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { Container } from '@material-ui/core'
import { Stepper, Step } from '@progress/kendo-react-layout'
import { Button } from '@progress/kendo-react-buttons'
import { Form, FormElement } from '@progress/kendo-react-form'
import { DialogPrivacy, DialogSystemGLPure } from '../../pures'
import govoLogo from './../../../assets/logos/logo_govo.legal.jpg'
import slogan from '../../../assets/logos/logo_finger_print.png'
import { Grid } from '@material-ui/core'
import './user-register.css'
import { LocalStorageService } from '../../../services'

const ButtonContainer = {
  marginTop: "15px",
  marginBottom: "15px",
  display: "flex",
  justifyContent: "center",
  paddingBottom: "20px",
};

const CustomStepItem = (props) => (
  <Step {...props}>
    <span className="k-step-indicator">
      <img src={props.icon} alt="" className="item-step-icon" />
    </span>
    <span className="k-step-label k-step-text label-stepper display-none ">
      {props.label ? props.label : props.itemSup}
    </span>
  </Step>
);

const UserRegisterView = (props) => {
  let StepComponent = props.stepMetadata[props.selectedStep].component;
  const { t, i18n } = useTranslation();
  const [clientLogo, setclientLogo] = useState(null);
  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    let localStorageService = new LocalStorageService();
    let logo = localStorageService.getLocalStorageItem("clientLogo");

    if (logo) {
      setclientLogo(logo);
    }
  }, []);

  useEffect(() => {
    let value = false;

    if (props.attempOfPayment) {
      if (props.a3Direct || (props.transfer && props.messageTransfer)) {
        value = true;
      } else if (
        (props.card & (props.selectedPersonTypeId === 1) &&
          props.personlDataFill &&
          props.selectedStep !== 4) ||
        (props.card & (props.selectedPersonTypeId === 2) &&
          props.selectedStep !== 5)
      ) {
        value = true;
      }
      // } else if (props.selectedPersonTypeId === 1 && props.personlDataFill && props.selectedStep !== 4) {
      //   value = true
    } else if (props.selectedPersonTypeId === 2) {
      if (props.selectedStep == 1 && props.personlDataFill) {
        value = true;
      } else if (props.selectedStep == 2 && props.businessDataFill) {
        value = true;
      } else if (
        props.personlDataFill &&
        props.businessDataFill &&
        props.selectedStep !== 5
      ) {
        value = true;
      } else {
        value = false;
      }
    } else {
      value = false;
    }

    setSubmit(value);
  }, [
    props.attempOfPayment,
    props.a3Direct,
    props.transfer,
    props.messageTransfer,
    props.card,
    props.selectedPersonTypeId,
    props.selectedStep,
    props.personlDataFill,
    props.businessDataFill,
  ]);

  props.changeTranslates(props.steps, t, i18n);

  let initialValues = {
    firstName: props.firstName,
    firstLastName: props.firstLastName,
    secondLastName: props.secondLastName,
    rfc: props.rfc,
    phoneNumber: props.phoneNumber,
    cellphoneNumber: props.cellphoneNumber,
    street: props.street,
    colony: props.colony,
    township: props.township,
    state: props.state,
    zipCode: props.zipCode,
    clientName: props.organization,
    colonyTaxData: props.colonyTaxData,
    stateTaxData: props.stateTaxData,
    streetTaxData: props.streetTaxData,
    townshipTaxData: props.townshipTaxData,
    zipCodeTaxData: props.zipCodeTaxData,
    clientName: props.clientName,
    rfcTaxData: props.rfcTaxData,
  };

  return (
    <div className='user-register user-registration-container'>
      <div className='user-registration-header-layout' >
        <Grid container justify='center' alignItems='center'>
          <div className='header-regiter-person' item>
            <div className='logo-register-person'><img alt='Logo de govo.legal' className='data-logo-person-header' width='247' height='48' src={govoLogo} /></div>
            {clientLogo && (
              <img
                alt="Logo del cliente"
                className="data-logo-person-header"
                style={{ height: "80px", padding: "0px", margin: "8px" }}
                src={clientLogo}
              />
            )}
            <div className="data-akubicafirmadigital-person">
              <p
                alt="Logo de govo.legal"
                className="data-akubicaFirmaDigital-person-img"
                height="70"
                align="center"
                src={slogan}
              >
                Slogan <br /> govo.digital
              </p>
            </div>
          </div>
        </Grid>
      </div>
      <div className="div-con-fondo  div-con-fondo-2 user-registration-contnet-layout">
        <Container
          fixed
          className="container user-register-container"
          spacing={4}
          data-aos="fade-left"
        >
          <Container col={12}>
            <div className="steps center stepper-movil">
              <Stepper
                value={props.selectedStep}
                items={props.steps}
                item={CustomStepItem}
              />
            </div>
          </Container>
          <Form
            initialValues={initialValues}
            allowSubmit={true}
            valid={true}
            modified={true}
            touched={true}
            viseted={true}
            onSubmit={props.onSubmit}
            render={(formRenderProps) => {
              return (
                <Container className="form">
                  <Container className="user-register-form" spacing={4}>
                    <FormElement className="center form-element-size">
                      <div className="title-stepper">
                        <div className="title-form-step">
                          <h3 className="user-register-title">
                            {props.steps[props.selectedStep].itemElement}.
                          </h3>
                        </div>
                        {/* <h4 className="user-register-steps">
                          {t("userRegisterView.steps")} {props.selectedStep + 1}{" "}
                          {t("userRegisterView.steps")} {props.steps.length}
                        </h4> */}
                      </div>
                      <StepComponent
                        {...props}
                        validator={props.validator}
                        regex={props.regex}
                        validateInput={props.validateInput}
                        selectedPersonTypeId={props.selectedPersonTypeId}
                      />
                      <div
                        style={ButtonContainer}
                        className="k-form-buttons buttons mb-3 "
                        spacing={4}
                      >
                        {props.contractCreated ? (
                          <Button
                            // primary={true}
                            className="user-register-button-accept-user-app"
                            onClick={(e) =>
                              props.isLastStep
                                ? props.goToApp()
                                : props.onSubmit()
                            }
                          >
                            {props.isLastStep
                              ? "Ir a la aplicación"
                              : "Continuar"}
                          </Button>
                        ) : (
                          <>
                            <Button
                              // primary={true}
                              className='user-register-button-accept-user'
                              onClick={(e) => props.onBackStep(e)}>
                              {props.steps[props.selectedStep].labelreturn}
                            </Button>
                            <Button
                              type={'submit'}
                              // primary={true}
                              style={{ marginLeft: '15px' }}
                              className='user-register-button-accept-user-app'
                              onClick={(event) => ((submit && !formRenderProps.allowSubmit && formRenderProps.valid)) ? props.onSubmit(event) : null}
                            >
                              {props.a3Direct ? 'Continuar' : props.steps[props.selectedStep].itemSup}
                            </Button>
                          </>
                        )
                        }
                      </div>
                    </FormElement>
                  </Container>
                </Container>
              );
            }}
          />
        </Container>
      </div>
      <div className="user-registration-footer-layout">
        <DialogSystemGLPure
          {...props}
          message={props.message}
          messageComplete={props.messageComplete}
          toggleErrorRequesting={props.toggleErrorRequesting}
          toggleWarningRequesting={props.toggleWarningRequesting}
          showCompletedRequesting={props.showCompletedRequesting}
        />
        <Grid container justify="center" alignItems="center">
          <div className="footer-register-person" item>
            <div className="footer-elements">
              <div className="footer-textR-person">
                <h2>Powered by A3 Cloud Microservices, S.A.P.I. de C.V.</h2>
              </div>
              <div className="footer-textL-person">
                <h2
                  onClick={() => {
                    props.openModalTermsCond(true);
                  }}
                >
                  Aviso de Privacidad
                </h2>
                {/*<hr class="linkHref"/>*/}
              </div>
            </div>
          </div>
        </Grid>
        <DialogPrivacy {...props} />
      </div>
    </div>
  );
};

export { UserRegisterView as default };
